// extracted by mini-css-extract-plugin
module.exports = {"loading":"PostBookingPaymentInnerLoader-module__loading___WcQO5"};